class HHAccordion extends HTMLElement {
  constructor() {
    super()

    this.toggle = this.querySelector('.js-accordion-toggle')
  }

  get isOpen() {
    return this.toggle.getAttribute('aria-expanded') === 'true'
  }

  connectedCallback() {
    this.toggle?.addEventListener('click', this.handleToggle.bind(this))
  }

  handleToggle(e) {
    e.preventDefault()
    this.toggle.setAttribute('aria-expanded', this.isOpen ? 'false' : 'true')
  }
}

window.customElements.define('hh-accordion', HHAccordion)
